module.exports = __webpack_public_path__ + "static/media/descending.ee71868e.svg";